export const userProfile = {
  user_personalInformation: "My personal information",
  user_alias: "Alias",
  user_alias_edit: "Edit alias",
  user_alias_placeholder: "Choose your alias",
  user_alias_save: "Save",
  user_alias_cancel: "Cancel",
  user_alias_saving: "Saving...",
  user_alias_success: "Alias updated",
  user_alias_error: "Could not update alias",
  user_alias_unavailable: "This alias is already in use",
  user_alias_checking: "Checking...",
  user_alias_available: "Available",
  user_alias_min_length: "Minimum 3 characters",
  user_name: "Name",
  user_lastName: "Last Name",
  user_email: "Email",
  user_phoneNumber: "Phone Number",
  user_birthdate: "Date of Birth",
  user_national_id: "ID Number",
  user_state: "State",
  user_city: "City",
  user_support_message: "To make any changes or updates to your profile, please contact our",
  user_support_link: "technical support",

  userProfileImageFormat: "Unsupported format",
  userProfileImageFormatDesc: "Only JPEG, JPG, or PNG images are allowed.",
  userProfileImageSize: "Image too large",
  userProfileImageSizeDesc: "The maximum allowed size is 3MB.",
  userProfileImageEdit: "Edit",

  profileFollowers: "Followers",
  profileFollowing: "Following",
  profileFavoriteGames: "Favorite Games",
  profileRecentGames: "Recent Games",
  profileFavoriteProviders: "Followed Providers",
  profileEditProfile: "Edit Profile",
  profileKeepPlaying: "Keep Playing",
  profileFollow: "Follow",
  profileNoFavorites: "No favorite games yet",
  profileNoFavoritesDesc: "Games you mark as favorites will appear here",
  profileNoRecentGames: "No recent games",
  profileNoRecentGamesDesc: "Games you play will appear here",
  profileNoProviders: "You're not following any providers yet",
  profileGamesCount: "{{count}} games",

  profileHighlightBigWins: "Big Wins",
  profileHighlightFavorites: "Favorites",
  profileHighlightRecent: "Recent",
  profileHighlightLatestWinners: "Latest Winners",
  profileHighlightPopularGames: "Popular Games",
  profileHighlightLastPlayed: "Last Played",
  profileHighlightNoWins: "No big wins recorded yet",

  profileFeedTabs: "Profile feed tabs",
  profileNoBigWins: "No big wins yet",
  profileNoBigWinsDesc: "Your winning moments will appear here",

  profileNoFollowers: "No followers yet",
  profileNoFollowing: "Not following anyone yet",
  profileFollowersSoon: "This feature will be available soon",

  friendAddFriend: "Follow",
  friendStatusPending: "Request sent",
  friendStatusFriends: "Friends",
  friendRequestSentToast: "Friend request sent",
  friendRequestSentTitle: "Request sent",
  friendRequestSentBody: "Your friend request has been sent",
  friendRequestReceivedTitle: "Friend request",
  friendRequestReceivedBody: "{{alias}} sent you a friend request",
  friendUnfriendTitle: "Unfriend?",
  friendUnfriendDescription: "Do you want to unfriend @{{alias}}?",
  friendUnfriendConfirm: "Confirm",
  friendUnfriendCancel: "Cancel",
  friendUnfriendLoading: "Removing...",
};
